export { default } from './SyntaxHighlighter';
